export default __webpack_public_path__ + "static/compatibility-ec931ab2d3e70e0423405cdbfe665772.svg";